import { actionTypes } from '../actions/transaction.action';
const initialState = {
    transactions: {
        data: []
    },
    transaction: {},
    user: {
        transactions: {
            data: []
        },
        transaction: {}
    },
    user_id: null,
    count: null,
    account: {},
    error: {},
    success: false
}

const TransactionReducer = (state = initialState, { type, payload, isLoadMore, user_id }) => {
    switch (type) {

    case actionTypes.INDEX:
        if(payload.user_id) {
            if(isLoadMore) {
                payload.transactions.data = state.user.transactions.data.concat(payload.transactions.data)
            }
            
            return { 
                ...state,
                user: {
                    ...state.user,
                    ...payload
                } 
            }
        }

        if(isLoadMore) {
            payload.transactions.data = state.transactions.data.concat(payload.transactions.data)
        }

        return { ...state, ...payload }

    case actionTypes.UPDATE:
        let index = state.cotas.data.findIndex(item => item.id === payload.id)
        state.transactions.data[index] = payload

        return {
            ...state,
            transactions: {
                ...state.transactions,
                data: [
                    ...[(index < 0) && payload],
                    ...state.transactions.data
                ]
            }
        }

    case actionTypes.SUCCESS:
        return {
            ...state,
            success: payload
        }

    case actionTypes.ERROR:
        return {
            ...state,
            error: payload
        }

    default:
        return state
    }
}

export default TransactionReducer